export const KeySequence = {
    PROBLEMS_PANEL: 'd d e',
    PROJECT_HISTORY_DIALOG: 'd d h',
    CREATE_PROJECT_DIALOG: 'd d p',
    WAREHOUSE_LOAD_DIALOG: 'd d w'
};
